import { AuthService } from 'src/app/services/auth.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-delete-payment-info',
  templateUrl: './delete-payment-info.component.html',
  styleUrls: ['./delete-payment-info.component.css']
})
export class DeletePaymentInfoComponent implements OnInit {

  faTimesCircle=faTimesCircle;
  customerPaymentMethodID: any;

  constructor(
    private dialogRef: MatDialogRef<DeletePaymentInfoComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private dialog: MatDialog,
    private authService:AuthService
    ) {

  }

  ngOnInit() {
    if(this.data!=null&&this.data.customerPaymentMethodID!=null){
      this.customerPaymentMethodID=this.data.customerPaymentMethodID;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  confirmDelete(){
    this.authService.deleteCustomerPaymentMethods(this.customerPaymentMethodID).subscribe(res =>{
      this.dialogRef.close({success:true});
    })
  }

}
